.shell {
  display: grid;
  grid-template-columns: 260px 1fr;
  height: 100%;
}

.sidebar {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  padding: 24px var(--space-4);
  background: var(--chrome);
  color: var(--chrome-text);
  min-height: 0;
  overflow-y: auto;
}

.brand {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-2);
  padding: 0 var(--space-1);
}

/* The logo's dark letters need a light plate on the dark sidebar. */
.logo {
  display: block;
  height: 40px;
  width: auto;
  box-sizing: content-box;
  padding: 10px 12px;
  background: #ffffff;
  border-radius: 12px;
}

.eyebrow {
  color: var(--eyebrow);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.label {
  margin: 0;
  color: var(--chrome-muted);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.field {
  composes: label;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 0 var(--space-1);
}

.projectSelect {
  font: inherit;
  font-weight: 600;
  padding: var(--space-1) var(--space-2);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  background: var(--surface);
  color: var(--text);
}

.field .projectSelect {
  min-height: 40px;
  padding: 0 var(--space-3);
  border: 0;
  background: rgb(255 255 255 / 10%);
  color: var(--chrome-text);
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: none;
}

.projectSelect option {
  background: var(--surface);
  color: var(--text);
}

.newChat {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 40px;
  padding: 0 14px;
  border: 0;
  border-radius: var(--radius);
  background: var(--accent);
  color: var(--chrome-text);
  font-weight: 700;
  cursor: pointer;
}

.newChat:hover {
  filter: brightness(1.08);
}

.nav {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.navItem {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  min-height: 40px;
  padding: 0 var(--space-3);
  border-radius: var(--radius);
  color: var(--chrome-muted);
  text-decoration: none;
}

.badge {
  margin-left: auto;
  min-width: 22px;
  height: 22px;
  padding: 0 6px;
  border-radius: 999px;
  background: var(--eyebrow);
  color: #ffffff;
  font-size: 12px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.navItem:hover,
.chat:hover {
  background: rgb(255 255 255 / 8%);
  color: var(--chrome-text);
}

.navItem[aria-current='page'],
.chat[aria-current='true'] {
  background: rgb(255 255 255 / 12%);
  color: var(--chrome-text);
  font-weight: 700;
}

.recent {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-height: 0;
  flex: 1;
}

.recent .label {
  padding: 0 var(--space-3) 6px;
}

.chats {
  list-style: none;
  margin: 0;
  padding: 0;
  overflow-y: auto;
}

.chat {
  display: block;
  width: 100%;
  min-height: 36px;
  text-align: left;
  border: 0;
  background: transparent;
  color: var(--chrome-muted);
  font-size: 14px;
  padding: 6px var(--space-3);
  border-radius: 8px;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.muted {
  margin: 0;
  color: var(--chrome-muted);
  font-size: 14px;
  padding: 0 var(--space-3);
}

.person {
  border-top: 1px solid rgb(255 255 255 / 15%);
  padding: var(--space-4) var(--space-1) 0;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.name {
  min-width: 0;
  overflow-wrap: anywhere;
}

.person a {
  margin-left: auto;
  color: var(--chrome-text);
}

.avatar {
  flex: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  color: var(--chrome);
  font-size: 12px;
  font-weight: 700;
}

/* One colour per tone of avatarTone(); Prussian Blue text keeps at least 4:1 contrast on each. */
.avatar[data-tone='0'] {
  background: #009db3;
}

.avatar[data-tone='1'] {
  background: #8ac4e0;
}

.avatar[data-tone='2'] {
  background: #ffb703;
}

.avatar[data-tone='3'] {
  background: #fb8500;
}

.signIn {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.signIn .brand {
  align-items: center;
}

.signInButton {
  display: inline-block;
  margin-top: var(--space-2);
  background: var(--accent);
  color: var(--accent-text);
  border-radius: var(--radius);
  padding: var(--space-2) var(--space-4);
  font-weight: 700;
  text-decoration: none;
}

.content {
  display: flex;
  flex-direction: column;
  min-height: 0;
  min-width: 0;
}

.header {
  background: var(--chrome);
  color: var(--chrome-text);
  padding: 24px 40px 22px;
  border-left: 1px solid rgb(255 255 255 / 10%);
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: flex-end;
  justify-content: space-between;
}

.headerText {
  min-width: 0;
}

.headerActions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.headerButton {
  min-height: 44px;
  padding: 0 16px;
  border: none;
  border-radius: var(--radius);
  background: var(--accent);
  color: var(--accent-text);
  font: inherit;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
}

.title {
  margin: var(--space-2) 0 6px;
  font-size: 28px;
  line-height: 1.1;
  overflow-wrap: anywhere;
}

.subtitle {
  margin: 0;
  color: var(--chrome-muted);
  font-size: 14px;
}

.main {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  min-width: 0;
  position: relative;
}

.placeholder {
  display: grid;
  place-items: center;
  flex: 1;
  color: var(--muted);
}

.page {
  display: grid;
  place-items: center;
  height: 100%;
  color: var(--muted);
}

@media (max-width: 720px) {
  .shell {
    grid-template-columns: 1fr;
    grid-template-rows: auto 1fr;
  }

  .sidebar {
    max-height: 35vh;
  }
}
